// src/components/DisclaimerBanner.js
//
// Reusable plain-English legal disclaimer.
// Appears on: triage results, assessment header, chat start state.
//
// Variants:
//   'inline'  — subtle, text-only, blends into page flow (default)
//   'banner'  — bordered box, higher visual weight
//   'compact' — single line, for tight spaces like chat headers

import React from 'react'

export default function DisclaimerBanner({ variant = 'inline', className = '' }) {
  const text =
    'HolaSam provides educational tax orientation, not tax, legal, or accounting advice. ' +
    'Do not file or make financial decisions based only on this. ' +
    'For your situation, consult a qualified professional.'

  if (variant === 'compact') {
    return (
      <p className={`disclaimer-compact ${className}`}>
        Educational guidance only — not tax or legal advice.{' '}
        <a href="/terms" className="disclaimer-link">Terms</a>
        {' · '}
        <a href="/privacy" className="disclaimer-link">Privacy</a>
      </p>
    )
  }

  if (variant === 'banner') {
    return (
      <div className={`disclaimer-banner ${className}`} role="note" aria-label="Legal disclaimer">
        <span className="disclaimer-icon" aria-hidden="true">ℹ</span>
        <p className="disclaimer-text">{text}</p>
      </div>
    )
  }

  // Default: inline
  return (
    <p className={`disclaimer-inline ${className}`} role="note">
      {text}{' '}
      <a href="/terms" className="disclaimer-link">Terms</a>
      {' · '}
      <a href="/privacy" className="disclaimer-link">Privacy</a>
    </p>
  )
}
